import React, { useEffect, useState } from "react";
import CreateReply from "./CreateReply";
import TeamService from "services/TeamService";
import Button from "components/CustomButton";
import Reply from "./Reply";
import Loader from "components/Loader";
import { RepliesContext } from "store/contexts/repliesContext";
import { useExpressionsContext } from "store/contexts/expressionsContext";
import { useTeamContext } from "store/contexts/teamContext";

function RepliesList({ listTask, expression }) {
  const { team } = useTeamContext();
  const [replies, setReplies] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const { updateExpression, reply_id, setReplyId } = useExpressionsContext();

  useEffect(() => {
    setIsLoading(true);
    if (reply_id && replies.length !== 0) {
      setReplies([]);
    }

    (async () => {
      try {
        if (!reply_id || reply_id === "undefined") {
          const response = await TeamService.getListTaskExpressions(
            team.id,
            listTask.todo_list_id,
            listTask.id,
            { page: page, parent_expression_id: expression?.id }
          );

          setIsLoading(false);
          setMeta(response.data.meta);
          setReplies(Array.from(new Set([...replies, ...response.data.data])));
          return;
        }

        const response = await TeamService.getSingleListItemExpression(
          team.id,
          listTask.todo_list_id,
          listTask.id,
          reply_id
        );

        setIsLoading(false);
        setMeta(0);
        setReplies([response.data.data]);
      } catch (e) {
        console.log(e);
      }
    })();
    //eslint-disable-next-line
  }, [page, reply_id]);

  const createReply = (reply) => {
    setReplies(Array.from(new Set([reply, ...replies])));
  };

  const deleteReply = (newReply) => {
    var newExpressions = replies.filter(
      (replies) => replies.id !== newReply.id
    );

    const expressionCopy = { ...expression };
    expressionCopy.replies_count -= 1;
    updateExpression(expressionCopy);

    setReplies(newExpressions);
  };

  const updateReply = (reply) => {
    const repliesCopy = [...replies];

    repliesCopy[
      repliesCopy.findIndex((tReply) => {
        return tReply.id === reply.id;
      })
    ] = {
      ...reply,
    };

    setReplies(repliesCopy);
  };

  const viewMore = () => {
    if (!reply_id) {
      setPage(page + 1);
      return;
    }
    setReplyId(null);
    setReplies([]);
  };

  return (
    <RepliesContext.Provider
      value={{
        updateReply,
        createReply,
        deleteReply,
      }}
    >
      <div className="post_comments-section">
        <CreateReply listTask={listTask} expression={expression} />
        <div>
          {replies.map((reply) => (
            <Reply
              reply={reply}
              key={reply.id}
              listTask={listTask}
              disableExpression={true}
            />
          ))}
          {reply_id && reply_id !== "undefined" && !isLoading && (
            <div className="viewAllButton">
              <Button buttonClass={"grad_btn join-btn"} onClick={viewMore}>
                View All
              </Button>
            </div>
          )}
          {page !== meta?.last_page && !isLoading && !reply_id && (
            <div className="viewAllButton">
              <Button
                buttonClass={"grad_btn join-btn"}
                onClick={() => setPage(page + 1)}
              >
                Load More
              </Button>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </div>
    </RepliesContext.Provider>
  );
}

export default RepliesList;
